// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"fcc5762e","165":"99893db5","227":"137f59c1","453":"926f0775","648":"1ec7321c","989":"9ef46757"}[chunkId] + ".chunk.js";
};